import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ContentfulPage from "../../ContentfulPage";
import { HomeMenu } from "views/UIelems/v2/Header/HomeMenu";
import { PAGE_IDS } from "../../constants";
const LandingPageWrapper = ({ slug, preview, parsedFunctions = {} }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HomeMenu, {}), _jsx(ContentfulPage, { contentTag: PAGE_IDS.LANDING_PAGE, identifier: slug, isStatic: false, preview: preview, parsedFunctions: parsedFunctions }, slug)] }));
};
export default LandingPageWrapper;
